<script lang="ts">
    
    import { createEventDispatcher } from 'svelte';
    import { fly } from 'svelte/transition';
    import IconChevron from './IconChevron.svelte';

    export let title: string = '';
    export let flex = false;
    export let closeBlink = false;

    const dispatch = createEventDispatcher();

    function onClose(): void {
        dispatch('close');
    }

</script>

<div class="activity-modal" transition:fly={{ x: 100 }}>
    <div class="header">
        <button type="button" class="close-btn" class:blink={closeBlink} on:click={onClose}>
            <IconChevron />
        </button>
        <div class="title">{title}</div>
    </div>
    <div class="content" class:flex>
        <slot />
    </div>
</div>

<style lang="scss">

    .activity-modal {
        position: fixed;
        z-index: 50;
        top: 0;
        left: 0;
        width: 100vw;
        height: var(--vh, 100vh);
        touch-action: auto;
        pointer-events: auto;
        background-color: #fff;
        display: flex;
        flex-direction: column;
    }

    .header {
        height: 60px;
        display: flex;
        align-items: center;
        padding: 5px;
        box-sizing: border-box;
    }

    .close-btn {
        width: 50px;
        height: 50px;
        border: none;
        border-radius: 50%;
        background-color: #fff;

        &.blink {
            animation-name: blink;
            animation-duration: 1s;
            animation-iteration-count: infinite;
        }
    }

    .title {
        width: calc(100% - 120px);
        display: flex;
        justify-content: center;
        align-items: center;
        color: #000;
        font-size: 1.2rem;
    }

    .content {
        flex: 1 1 0;
        overflow: auto;

        &.flex {
            display: flex;
            flex-direction: column;
        }
    }

    @keyframes blink {
        0%, 100% {
            filter: invert(0);
        }
        50% {
            filter: invert(1);
        }
    }

</style>
